import React from 'react';
import { MessageCircle } from 'lucide-react';

// Floating WhatsApp chat button — opens chat on click.
// Replace PHONE with your Pallavit WhatsApp business number when available.
const PHONE = '919403707272'; // Pallavit WhatsApp
const MESSAGE = encodeURIComponent("Hi Pallavit, I'd love to know more about gifting a tree.");

export default function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${MESSAGE}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label="Chat with Pallavit on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 inline-flex items-center gap-3 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/15 pl-4 pr-5 py-3 hover:-translate-y-0.5 hover:shadow-xl transition-all duration-500"
    >
      <span className="relative inline-flex items-center justify-center w-9 h-9 rounded-full bg-white/15">
        <MessageCircle className="w-5 h-5" strokeWidth={2} />
        <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-white animate-pulse" />
      </span>
      <span className="hidden sm:inline text-sm font-medium tracking-wide">Chat with us</span>
    </a>
  );
}
